/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * dhl-parcel-user-service
 * OpenAPI spec version: 1.0.0-20241111-163803-db7248d3
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import { useMutator } from '../../useMutator';
import type { ErrorType } from '../../useMutator';
export interface CheckMigrationResponse {
  startMigration: boolean;
}

/**
 * Current user response
 */
export interface CurrentUserResponse {
  user: UserDto;
}

export interface ErrorDto {
  key: string;
  message: string;
}

/**
 * Login as another user
 */
export interface LoginAsRequest {
  /** login token */
  token: string;
}

/**
 * Credentials of the user to login
 */
export interface LoginRequest {
  /** email address of the user */
  email: string;
  /** password associated with the email address */
  password: string;
}

/**
 * Change first name / last name of a user
 */
export interface NameRequest {
  /** first name of the user */
  firstName?: string;
  /** last name of the user */
  lastName?: string;
}

/**
 * Reset password
 */
export interface PasswordReset {
  /** email address of the user */
  email: string;
  /** token for password reset */
  token: string;
  /** new password for user */
  newPassword: string;
}

/**
 * Reset password request
 */
export interface RequestPasswordReset {
  /** email address of the user */
  email: string;
}

/**
 * No current user response
 */
export interface UnknownUserResponse {
  key: string;
  message: string;
}

/**
 * User account
 */
export interface UserAccountDto {
  /** user account number */
  id: string;
  /** user id */
  userId: string;
}

/**
 * Login response
 */
export interface UserDto {
  userType: UserType;
  /** user email */
  email: string;
  /** user id */
  userId: string;
  name: UserNameDto;
  /** user account */
  accounts?: UserAccountDto[];
  /** user organisation (business user only) */
  organisationId?: string;
  /** user parcelshop key (parcelshop user only) */
  parcelShopPsfKey?: string;
  /** parcelshop users (parcelshop user only) */
  parcelShopServices?: string[];
  /** user roles */
  roles?: string[];
  origin: UserOrigin;
}

/**
 * user name
 */
export interface UserNameDto {
  /** first name of the user */
  firstName?: string;
  /** last name of the user */
  lastName?: string;
  /** company name of the business user */
  companyName?: string;
  /** additional name of the company */
  additionalName?: string;
}

/**
 * user origin
 */
export type UserOrigin = typeof UserOrigin[keyof typeof UserOrigin];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserOrigin = {
  apple: 'apple',
  google: 'google',
  dhl: 'dhl',
} as const;

/**
 * user type
 */
export type UserType = typeof UserType[keyof typeof UserType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserType = {
  parcelShop: 'parcelShop',
  consumer: 'consumer',
  business: 'business',
  accountManager: 'accountManager',
  terminal: 'terminal',
} as const;

export type GetUserSocialAppleLoginParams = {
referrer?: string;
is_native?: boolean;
};

export type GetUserSocialAppleFinishParams = {
data: string;
};

export type GetUserSocialGoogleLoginParams = {
referrer?: string;
is_native?: boolean;
};

export type GetUserSocialGoogleConsentParams = {
state: string;
code: string;
};

export type GetUserSocialGoogleFinishParams = {
data: string;
};

export type GetUserLoginAsParams = {
token: string;
};

export type PostUserRequestPasswordResetParams = {
'x-lang'?: string;
};

export type GetUserMigrateAuthenticationInitParams = {
/**
 * Supply the path to return to after the migration completes (successful or not). Remark: For cleanest UX this should be the path of the frontend at time of initialising the migration.
 * @maxLength 1024
 */
returnToPath?: string;
};

export type GetUserMigrateAuthenticationCompleteParams = {
token: string;
/**
 * Supply the path to return to after the migration completes (successful or not). Remark: For cleanest UX this should be the path of the frontend at time of initialising the migration.
 * @maxLength 1024
 */
returnToPath?: string;
};

/**
 * Redirects the user to a Sign in with Apple page.
 * @summary Initialises Sign in with Apple
 */
export const useGetUserSocialAppleLoginHook = () => {
        const getUserSocialAppleLogin = useMutator<unknown>();

        return useCallback((
    params?: GetUserSocialAppleLoginParams,
 signal?: AbortSignal
) => {
        return getUserSocialAppleLogin(
          {url: `/user/social/apple/login`, method: 'GET',
        params, signal
    },
          );
        }, [getUserSocialAppleLogin])
      }
    

export const getGetUserSocialAppleLoginQueryKey = (params?: GetUserSocialAppleLoginParams,) => {
    return [`/user/social/apple/login`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserSocialAppleLoginQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(params?: GetUserSocialAppleLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSocialAppleLoginQueryKey(params);

  const getUserSocialAppleLogin =  useGetUserSocialAppleLoginHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>> = ({ signal }) => getUserSocialAppleLogin(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSocialAppleLoginQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>>
export type GetUserSocialAppleLoginQueryError = ErrorType<null | ErrorDto>


export function useGetUserSocialAppleLogin<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: undefined |  GetUserSocialAppleLoginParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialAppleLogin<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserSocialAppleLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialAppleLogin<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserSocialAppleLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Initialises Sign in with Apple
 */

export function useGetUserSocialAppleLogin<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserSocialAppleLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleLoginHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserSocialAppleLoginQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The user will be redirected to a url where the login is finished
 * @summary User completes Sign in with Apple form
 */
export const usePostUserSocialAppleConsentHook = () => {
        const postUserSocialAppleConsent = useMutator<unknown>();

        return useCallback((
    postUserSocialAppleConsentBody: string,
 signal?: AbortSignal
) => {const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append('data', postUserSocialAppleConsentBody)

        return postUserSocialAppleConsent(
          {url: `/user/social/apple/consent`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded, signal
    },
          );
        }, [postUserSocialAppleConsent])
      }
    


export const usePostUserSocialAppleConsentMutationOptions = <TError = ErrorType<null | ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserSocialAppleConsentHook>>>, TError,{data: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserSocialAppleConsentHook>>>, TError,{data: string}, TContext> => {

const mutationKey = ['postUserSocialAppleConsent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postUserSocialAppleConsent =  usePostUserSocialAppleConsentHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserSocialAppleConsentHook>>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  postUserSocialAppleConsent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserSocialAppleConsentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserSocialAppleConsentHook>>>>
    export type PostUserSocialAppleConsentMutationBody = string
    export type PostUserSocialAppleConsentMutationError = ErrorType<null | ErrorDto>

    /**
 * @summary User completes Sign in with Apple form
 */
export const usePostUserSocialAppleConsent = <TError = ErrorType<null | ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserSocialAppleConsentHook>>>, TError,{data: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserSocialAppleConsentHook>>>,
        TError,
        {data: string},
        TContext
      > => {

      const mutationOptions = usePostUserSocialAppleConsentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Finishes a login, a consumer user is created if there is no user with the associated email address.
 * @summary Finishes Sign in with Apple
 */
export const useGetUserSocialAppleFinishHook = () => {
        const getUserSocialAppleFinish = useMutator<unknown>();

        return useCallback((
    params: GetUserSocialAppleFinishParams,
 signal?: AbortSignal
) => {
        return getUserSocialAppleFinish(
          {url: `/user/social/apple/finish`, method: 'GET',
        params, signal
    },
          );
        }, [getUserSocialAppleFinish])
      }
    

export const getGetUserSocialAppleFinishQueryKey = (params?: GetUserSocialAppleFinishParams,) => {
    return [`/user/social/apple/finish`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserSocialAppleFinishQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(params: GetUserSocialAppleFinishParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSocialAppleFinishQueryKey(params);

  const getUserSocialAppleFinish =  useGetUserSocialAppleFinishHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>> = ({ signal }) => getUserSocialAppleFinish(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSocialAppleFinishQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>>
export type GetUserSocialAppleFinishQueryError = ErrorType<null | ErrorDto>


export function useGetUserSocialAppleFinish<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialAppleFinishParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialAppleFinish<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialAppleFinishParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialAppleFinish<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialAppleFinishParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Finishes Sign in with Apple
 */

export function useGetUserSocialAppleFinish<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialAppleFinishParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialAppleFinishHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserSocialAppleFinishQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Health check of the user service
 * @summary Health check of the user service
 */
export const useGetStatusHook = () => {
        const getStatus = useMutator<null>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getStatus(
          {url: `/status`, method: 'GET', signal
    },
          );
        }, [getStatus])
      }
    

export const getGetStatusQueryKey = () => {
    return [`/status`] as const;
    }

    
export const useGetStatusQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatusQueryKey();

  const getStatus =  useGetStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>> = ({ signal }) => getStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>>
export type GetStatusQueryError = ErrorType<unknown>


export function useGetStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health check of the user service
 */

export function useGetStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetStatusQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Redirects the user to a google login page.
 * @summary Initialises a Google login
 */
export const useGetUserSocialGoogleLoginHook = () => {
        const getUserSocialGoogleLogin = useMutator<unknown>();

        return useCallback((
    params?: GetUserSocialGoogleLoginParams,
 signal?: AbortSignal
) => {
        return getUserSocialGoogleLogin(
          {url: `/user/social/google/login`, method: 'GET',
        params, signal
    },
          );
        }, [getUserSocialGoogleLogin])
      }
    

export const getGetUserSocialGoogleLoginQueryKey = (params?: GetUserSocialGoogleLoginParams,) => {
    return [`/user/social/google/login`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserSocialGoogleLoginQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(params?: GetUserSocialGoogleLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSocialGoogleLoginQueryKey(params);

  const getUserSocialGoogleLogin =  useGetUserSocialGoogleLoginHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>> = ({ signal }) => getUserSocialGoogleLogin(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSocialGoogleLoginQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>>
export type GetUserSocialGoogleLoginQueryError = ErrorType<null | ErrorDto>


export function useGetUserSocialGoogleLogin<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: undefined |  GetUserSocialGoogleLoginParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialGoogleLogin<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserSocialGoogleLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialGoogleLogin<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserSocialGoogleLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Initialises a Google login
 */

export function useGetUserSocialGoogleLogin<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserSocialGoogleLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleLoginHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserSocialGoogleLoginQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The user will be redirected to a url where the login is finished
 * @summary User completes the Google login form
 */
export const useGetUserSocialGoogleConsentHook = () => {
        const getUserSocialGoogleConsent = useMutator<unknown>();

        return useCallback((
    params: GetUserSocialGoogleConsentParams,
 signal?: AbortSignal
) => {
        return getUserSocialGoogleConsent(
          {url: `/user/social/google/consent`, method: 'GET',
        params, signal
    },
          );
        }, [getUserSocialGoogleConsent])
      }
    

export const getGetUserSocialGoogleConsentQueryKey = (params?: GetUserSocialGoogleConsentParams,) => {
    return [`/user/social/google/consent`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserSocialGoogleConsentQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError = ErrorType<null | ErrorDto>>(params: GetUserSocialGoogleConsentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSocialGoogleConsentQueryKey(params);

  const getUserSocialGoogleConsent =  useGetUserSocialGoogleConsentHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>> = ({ signal }) => getUserSocialGoogleConsent(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSocialGoogleConsentQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>>
export type GetUserSocialGoogleConsentQueryError = ErrorType<null | ErrorDto>


export function useGetUserSocialGoogleConsent<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialGoogleConsentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialGoogleConsent<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialGoogleConsentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialGoogleConsent<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialGoogleConsentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary User completes the Google login form
 */

export function useGetUserSocialGoogleConsent<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialGoogleConsentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleConsentHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserSocialGoogleConsentQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Finishes a login, a consumer user is created if there is no user with the associated email address.
 * @summary Finishes logging in with Google
 */
export const useGetUserSocialGoogleFinishHook = () => {
        const getUserSocialGoogleFinish = useMutator<unknown>();

        return useCallback((
    params: GetUserSocialGoogleFinishParams,
 signal?: AbortSignal
) => {
        return getUserSocialGoogleFinish(
          {url: `/user/social/google/finish`, method: 'GET',
        params, signal
    },
          );
        }, [getUserSocialGoogleFinish])
      }
    

export const getGetUserSocialGoogleFinishQueryKey = (params?: GetUserSocialGoogleFinishParams,) => {
    return [`/user/social/google/finish`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserSocialGoogleFinishQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(params: GetUserSocialGoogleFinishParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSocialGoogleFinishQueryKey(params);

  const getUserSocialGoogleFinish =  useGetUserSocialGoogleFinishHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>> = ({ signal }) => getUserSocialGoogleFinish(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSocialGoogleFinishQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>>
export type GetUserSocialGoogleFinishQueryError = ErrorType<null | ErrorDto>


export function useGetUserSocialGoogleFinish<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialGoogleFinishParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialGoogleFinish<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialGoogleFinishParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSocialGoogleFinish<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialGoogleFinishParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Finishes logging in with Google
 */

export function useGetUserSocialGoogleFinish<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserSocialGoogleFinishParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSocialGoogleFinishHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserSocialGoogleFinishQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Log in the user and create all associated security tokens
 * @summary User login
 */
export const usePostUserLoginHook = () => {
        const postUserLogin = useMutator<UserDto>();

        return useCallback((
    loginRequest: LoginRequest,
 signal?: AbortSignal
) => {
        return postUserLogin(
          {url: `/user/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
          );
        }, [postUserLogin])
      }
    


export const usePostUserLoginMutationOptions = <TError = ErrorType<ErrorDto | ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLoginHook>>>, TError,{data: LoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLoginHook>>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['postUserLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postUserLogin =  usePostUserLoginHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserLoginHook>>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUserLogin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserLoginMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserLoginHook>>>>
    export type PostUserLoginMutationBody = LoginRequest
    export type PostUserLoginMutationError = ErrorType<ErrorDto | ErrorDto>

    /**
 * @summary User login
 */
export const usePostUserLogin = <TError = ErrorType<ErrorDto | ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLoginHook>>>, TError,{data: LoginRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserLoginHook>>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = usePostUserLoginMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Admin uses token to log in as the user and create all associated security tokens
 * @deprecated
 * @summary Admin login as user
 */
export const useGetUserLoginAsHook = () => {
        const getUserLoginAs = useMutator<unknown>();

        return useCallback((
    params: GetUserLoginAsParams,
 signal?: AbortSignal
) => {
        return getUserLoginAs(
          {url: `/user/login-as`, method: 'GET',
        params, signal
    },
          );
        }, [getUserLoginAs])
      }
    

export const getGetUserLoginAsQueryKey = (params?: GetUserLoginAsParams,) => {
    return [`/user/login-as`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserLoginAsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError = ErrorType<null | ErrorDto | ErrorDto>>(params: GetUserLoginAsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLoginAsQueryKey(params);

  const getUserLoginAs =  useGetUserLoginAsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>> = ({ signal }) => getUserLoginAs(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserLoginAsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>>
export type GetUserLoginAsQueryError = ErrorType<null | ErrorDto | ErrorDto>


export function useGetUserLoginAs<TData = Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError = ErrorType<null | ErrorDto | ErrorDto>>(
 params: GetUserLoginAsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserLoginAs<TData = Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError = ErrorType<null | ErrorDto | ErrorDto>>(
 params: GetUserLoginAsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserLoginAs<TData = Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError = ErrorType<null | ErrorDto | ErrorDto>>(
 params: GetUserLoginAsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Admin login as user
 */

export function useGetUserLoginAs<TData = Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError = ErrorType<null | ErrorDto | ErrorDto>>(
 params: GetUserLoginAsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLoginAsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserLoginAsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Admin uses token to log in as the user and create all associated security tokens
 * @summary Admin login as user
 */
export const usePostUserLoginAsHook = () => {
        const postUserLoginAs = useMutator<unknown>();

        return useCallback((
    loginAsRequest: LoginAsRequest,
 signal?: AbortSignal
) => {
        return postUserLoginAs(
          {url: `/user/login-as`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginAsRequest, signal
    },
          );
        }, [postUserLoginAs])
      }
    


export const usePostUserLoginAsMutationOptions = <TError = ErrorType<null | ErrorDto | ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLoginAsHook>>>, TError,{data: LoginAsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLoginAsHook>>>, TError,{data: LoginAsRequest}, TContext> => {

const mutationKey = ['postUserLoginAs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postUserLoginAs =  usePostUserLoginAsHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserLoginAsHook>>>, {data: LoginAsRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUserLoginAs(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserLoginAsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserLoginAsHook>>>>
    export type PostUserLoginAsMutationBody = LoginAsRequest
    export type PostUserLoginAsMutationError = ErrorType<null | ErrorDto | ErrorDto>

    /**
 * @summary Admin login as user
 */
export const usePostUserLoginAs = <TError = ErrorType<null | ErrorDto | ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLoginAsHook>>>, TError,{data: LoginAsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserLoginAsHook>>>,
        TError,
        {data: LoginAsRequest},
        TContext
      > => {

      const mutationOptions = usePostUserLoginAsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get current user information from security tokens and refresh all associated security tokens
 * @summary Get current user
 */
export const useGetUserCurrentHook = () => {
        const getUserCurrent = useMutator<CurrentUserResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getUserCurrent(
          {url: `/user/current`, method: 'GET', signal
    },
          );
        }, [getUserCurrent])
      }
    

export const getGetUserCurrentQueryKey = () => {
    return [`/user/current`] as const;
    }

    
export const useGetUserCurrentQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError = ErrorType<ErrorDto | UnknownUserResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserCurrentQueryKey();

  const getUserCurrent =  useGetUserCurrentHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>> = ({ signal }) => getUserCurrent(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserCurrentQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>>
export type GetUserCurrentQueryError = ErrorType<ErrorDto | UnknownUserResponse>


export function useGetUserCurrent<TData = Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError = ErrorType<ErrorDto | UnknownUserResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserCurrent<TData = Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError = ErrorType<ErrorDto | UnknownUserResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserCurrent<TData = Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError = ErrorType<ErrorDto | UnknownUserResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user
 */

export function useGetUserCurrent<TData = Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError = ErrorType<ErrorDto | UnknownUserResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserCurrentHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserCurrentQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Log out the user and clears all associated security tokens
 * @summary User logout
 */
export const useGetUserLogoutHook = () => {
        const getUserLogout = useMutator<null>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getUserLogout(
          {url: `/user/logout`, method: 'GET', signal
    },
          );
        }, [getUserLogout])
      }
    

export const getGetUserLogoutQueryKey = () => {
    return [`/user/logout`] as const;
    }

    
export const useGetUserLogoutQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError = ErrorType<ErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLogoutQueryKey();

  const getUserLogout =  useGetUserLogoutHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>> = ({ signal }) => getUserLogout(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserLogoutQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>>
export type GetUserLogoutQueryError = ErrorType<ErrorDto>


export function useGetUserLogout<TData = Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError = ErrorType<ErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserLogout<TData = Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError = ErrorType<ErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserLogout<TData = Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError = ErrorType<ErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary User logout
 */

export function useGetUserLogout<TData = Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError = ErrorType<ErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserLogoutHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserLogoutQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Log out the user and clears all associated security tokens
 * @summary User logout
 */
export const usePostUserLogoutHook = () => {
        const postUserLogout = useMutator<null>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return postUserLogout(
          {url: `/user/logout`, method: 'POST', signal
    },
          );
        }, [postUserLogout])
      }
    


export const usePostUserLogoutMutationOptions = <TError = ErrorType<ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLogoutHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLogoutHook>>>, TError,void, TContext> => {

const mutationKey = ['postUserLogout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postUserLogout =  usePostUserLogoutHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserLogoutHook>>>, void> = () => {
          

          return  postUserLogout()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserLogoutMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserLogoutHook>>>>
    
    export type PostUserLogoutMutationError = ErrorType<ErrorDto>

    /**
 * @summary User logout
 */
export const usePostUserLogout = <TError = ErrorType<ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserLogoutHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserLogoutHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = usePostUserLogoutMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Request user password reset by email
 * @summary Request user password reset
 */
export const usePostUserRequestPasswordResetHook = () => {
        const postUserRequestPasswordReset = useMutator<null>();

        return useCallback((
    requestPasswordReset: RequestPasswordReset,
    params?: PostUserRequestPasswordResetParams,
 signal?: AbortSignal
) => {
        return postUserRequestPasswordReset(
          {url: `/user/request-password-reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestPasswordReset,
        params, signal
    },
          );
        }, [postUserRequestPasswordReset])
      }
    


export const usePostUserRequestPasswordResetMutationOptions = <TError = ErrorType<ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserRequestPasswordResetHook>>>, TError,{data: RequestPasswordReset;params?: PostUserRequestPasswordResetParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserRequestPasswordResetHook>>>, TError,{data: RequestPasswordReset;params?: PostUserRequestPasswordResetParams}, TContext> => {

const mutationKey = ['postUserRequestPasswordReset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postUserRequestPasswordReset =  usePostUserRequestPasswordResetHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserRequestPasswordResetHook>>>, {data: RequestPasswordReset;params?: PostUserRequestPasswordResetParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postUserRequestPasswordReset(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserRequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserRequestPasswordResetHook>>>>
    export type PostUserRequestPasswordResetMutationBody = RequestPasswordReset
    export type PostUserRequestPasswordResetMutationError = ErrorType<ErrorDto>

    /**
 * @summary Request user password reset
 */
export const usePostUserRequestPasswordReset = <TError = ErrorType<ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserRequestPasswordResetHook>>>, TError,{data: RequestPasswordReset;params?: PostUserRequestPasswordResetParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserRequestPasswordResetHook>>>,
        TError,
        {data: RequestPasswordReset;params?: PostUserRequestPasswordResetParams},
        TContext
      > => {

      const mutationOptions = usePostUserRequestPasswordResetMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Reset user password by email and token
 * @summary Reset user password
 */
export const usePostUserPasswordResetHook = () => {
        const postUserPasswordReset = useMutator<null>();

        return useCallback((
    passwordReset: PasswordReset,
 signal?: AbortSignal
) => {
        return postUserPasswordReset(
          {url: `/user/password-reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordReset, signal
    },
          );
        }, [postUserPasswordReset])
      }
    


export const usePostUserPasswordResetMutationOptions = <TError = ErrorType<ErrorDto | ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserPasswordResetHook>>>, TError,{data: PasswordReset}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserPasswordResetHook>>>, TError,{data: PasswordReset}, TContext> => {

const mutationKey = ['postUserPasswordReset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postUserPasswordReset =  usePostUserPasswordResetHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserPasswordResetHook>>>, {data: PasswordReset}> = (props) => {
          const {data} = props ?? {};

          return  postUserPasswordReset(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserPasswordResetMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserPasswordResetHook>>>>
    export type PostUserPasswordResetMutationBody = PasswordReset
    export type PostUserPasswordResetMutationError = ErrorType<ErrorDto | ErrorDto>

    /**
 * @summary Reset user password
 */
export const usePostUserPasswordReset = <TError = ErrorType<ErrorDto | ErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserPasswordResetHook>>>, TError,{data: PasswordReset}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserPasswordResetHook>>>,
        TError,
        {data: PasswordReset},
        TContext
      > => {

      const mutationOptions = usePostUserPasswordResetMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Update the first name and last name of a user
 * @summary Update user's name
 */
export const usePostUserUpdateNameHook = () => {
        const postUserUpdateName = useMutator<CurrentUserResponse>();

        return useCallback((
    nameRequest: NameRequest,
 signal?: AbortSignal
) => {
        return postUserUpdateName(
          {url: `/user/update-name`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nameRequest, signal
    },
          );
        }, [postUserUpdateName])
      }
    


export const usePostUserUpdateNameMutationOptions = <TError = ErrorType<ErrorDto | UnknownUserResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserUpdateNameHook>>>, TError,{data: NameRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserUpdateNameHook>>>, TError,{data: NameRequest}, TContext> => {

const mutationKey = ['postUserUpdateName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postUserUpdateName =  usePostUserUpdateNameHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserUpdateNameHook>>>, {data: NameRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUserUpdateName(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserUpdateNameMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserUpdateNameHook>>>>
    export type PostUserUpdateNameMutationBody = NameRequest
    export type PostUserUpdateNameMutationError = ErrorType<ErrorDto | UnknownUserResponse>

    /**
 * @summary Update user's name
 */
export const usePostUserUpdateName = <TError = ErrorType<ErrorDto | UnknownUserResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserUpdateNameHook>>>, TError,{data: NameRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserUpdateNameHook>>>,
        TError,
        {data: NameRequest},
        TContext
      > => {

      const mutationOptions = usePostUserUpdateNameMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 *  If the user is not logged in, then a migration may always be started (but it wont do anything when calling /api/user/migrate-authentication/init)
 * @summary Check that a migration may be started for a logged in user.
 */
export const useGetUserMigrateAuthenticationCheckHook = () => {
        const getUserMigrateAuthenticationCheck = useMutator<CheckMigrationResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getUserMigrateAuthenticationCheck(
          {url: `/user/migrate-authentication/check`, method: 'GET', signal
    },
          );
        }, [getUserMigrateAuthenticationCheck])
      }
    

export const getGetUserMigrateAuthenticationCheckQueryKey = () => {
    return [`/user/migrate-authentication/check`] as const;
    }

    
export const useGetUserMigrateAuthenticationCheckQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError = ErrorType<ErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserMigrateAuthenticationCheckQueryKey();

  const getUserMigrateAuthenticationCheck =  useGetUserMigrateAuthenticationCheckHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>> = ({ signal }) => getUserMigrateAuthenticationCheck(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserMigrateAuthenticationCheckQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>>
export type GetUserMigrateAuthenticationCheckQueryError = ErrorType<ErrorDto>


export function useGetUserMigrateAuthenticationCheck<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError = ErrorType<ErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserMigrateAuthenticationCheck<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError = ErrorType<ErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserMigrateAuthenticationCheck<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError = ErrorType<ErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check that a migration may be started for a logged in user.
 */

export function useGetUserMigrateAuthenticationCheck<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError = ErrorType<ErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCheckHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserMigrateAuthenticationCheckQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Initializes authentication migration to another domain. Useful for moving from dhlparcel to dhlecommerce.
 * @summary Create a migration token for the current logged in user.
 */
export const useGetUserMigrateAuthenticationInitHook = () => {
        const getUserMigrateAuthenticationInit = useMutator<unknown>();

        return useCallback((
    params?: GetUserMigrateAuthenticationInitParams,
 signal?: AbortSignal
) => {
        return getUserMigrateAuthenticationInit(
          {url: `/user/migrate-authentication/init`, method: 'GET',
        params, signal
    },
          );
        }, [getUserMigrateAuthenticationInit])
      }
    

export const getGetUserMigrateAuthenticationInitQueryKey = (params?: GetUserMigrateAuthenticationInitParams,) => {
    return [`/user/migrate-authentication/init`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserMigrateAuthenticationInitQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError = ErrorType<null | ErrorDto>>(params?: GetUserMigrateAuthenticationInitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserMigrateAuthenticationInitQueryKey(params);

  const getUserMigrateAuthenticationInit =  useGetUserMigrateAuthenticationInitHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>> = ({ signal }) => getUserMigrateAuthenticationInit(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserMigrateAuthenticationInitQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>>
export type GetUserMigrateAuthenticationInitQueryError = ErrorType<null | ErrorDto>


export function useGetUserMigrateAuthenticationInit<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: undefined |  GetUserMigrateAuthenticationInitParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserMigrateAuthenticationInit<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserMigrateAuthenticationInitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserMigrateAuthenticationInit<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserMigrateAuthenticationInitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create a migration token for the current logged in user.
 */

export function useGetUserMigrateAuthenticationInit<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError = ErrorType<null | ErrorDto>>(
 params?: GetUserMigrateAuthenticationInitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationInitHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserMigrateAuthenticationInitQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Initializes authentication migration to another domain. Useful for moving from dhlparcel to dhlecommerce.
 * @summary Migrate current user authentication
 */
export const useGetUserMigrateAuthenticationCompleteHook = () => {
        const getUserMigrateAuthenticationComplete = useMutator<unknown>();

        return useCallback((
    params: GetUserMigrateAuthenticationCompleteParams,
 signal?: AbortSignal
) => {
        return getUserMigrateAuthenticationComplete(
          {url: `/user/migrate-authentication/complete`, method: 'GET',
        params, signal
    },
          );
        }, [getUserMigrateAuthenticationComplete])
      }
    

export const getGetUserMigrateAuthenticationCompleteQueryKey = (params?: GetUserMigrateAuthenticationCompleteParams,) => {
    return [`/user/migrate-authentication/complete`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserMigrateAuthenticationCompleteQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError = ErrorType<null | ErrorDto>>(params: GetUserMigrateAuthenticationCompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserMigrateAuthenticationCompleteQueryKey(params);

  const getUserMigrateAuthenticationComplete =  useGetUserMigrateAuthenticationCompleteHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>> = ({ signal }) => getUserMigrateAuthenticationComplete(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserMigrateAuthenticationCompleteQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>>
export type GetUserMigrateAuthenticationCompleteQueryError = ErrorType<null | ErrorDto>


export function useGetUserMigrateAuthenticationComplete<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserMigrateAuthenticationCompleteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserMigrateAuthenticationComplete<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserMigrateAuthenticationCompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserMigrateAuthenticationComplete<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserMigrateAuthenticationCompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Migrate current user authentication
 */

export function useGetUserMigrateAuthenticationComplete<TData = Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError = ErrorType<null | ErrorDto>>(
 params: GetUserMigrateAuthenticationCompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserMigrateAuthenticationCompleteHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserMigrateAuthenticationCompleteQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
